const config = require('~/config/config.json');

export const redactorConfig = {
    buttons: ['undo', 'redo', 'format', 'bold', 'italic', 'lists', 'link', 'ai'],
    formatting: ['p', 'blockquote', 'pre', 'h1', 'h2', 'h3', 'h4', 'h5'],
    // Object keys (not array indexes) on purpose: the dropdown item gets the key
    // as its class suffix (redactor-dropdown-antrfile). A numeric key collides
    // with the per-editor dropdown container class (redactor-dropdown-{uuid},
    // uuid starts at 0), whose :visible children get hidden on toolbar scroll.
    formattingAdd: {
        antrfile: {
            title: 'Antrfile',
            args: ['blockquote', 'class', 'antrfile'],
        },
    },
    imageEditable: false,
    defaultImageAlignment: 'article-photo',
    defaultImageSizeId: 'original',
    minHeight: '300px',
    maxWidth: '660px',
    plugins: [
        'advanced',
        'alignment',
        'clips',
        'embedCode',
        'editPhotonImage',
        'fontcolor',
        'fontsize',
        'fullscreen',
        'source',
        'table',
        'video',
        'ai',
    ],
    script: true,
    spellcheck: config.spellcheck,
    toolbarFixed: true,
    toolbarOverflow: true,
    aiSystemPrompt: 'Use a professional tone to write an article about the given text. Always format response as HTML making sure that paragraphs are wrapped in p tags. Also feel free to use H2, and subsequent H tags, but H1 is already reserved - dont use H1. You can use bold, italic as required, and don\'t change other elements such as images or other embeds - you should leave them as is.',
};
